import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Woonggi Kim
 * @contact wgkim@detech.co.kr
 * @date 2024-03-27
 * @brief 공지사항 팝업
 *
 ********************************************************************/
import { useEffect, useRef, useState } from "react";
//recoil
// utils
import * as CONST from "../../../utils/Const";
import dayjs from "dayjs";
import { useTrans } from "../../../utils/langs/useTrans";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build";
export default function InformPop(props) {
    const t = useTrans();
    let item = props.item;
    let propsShow = props.isShow;
    const [isShow, setShow] = useState(false);
    const [inform, setInform] = useState({});
    const [iframe, setIframe] = useState(false);
    const [iframeUrl, setIframeUrl] = useState(null);
    let closeTodayRef = useRef(null);
    useEffect(() => { }, [item]);
    useEffect(() => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(inform.content, "text/html");
        let figureElement = doc.querySelector("figure");
        if (figureElement && figureElement.classList.contains("media")) {
            let media = document.querySelectorAll("oembed");
            // class 이름이 "media"인 경우
            Array.prototype.forEach.call(media, (element) => {
                setIframeUrl(element.getAttribute("url"));
            });
            setIframe(true);
        }
        else if (figureElement && figureElement.classList.contains("image")) {
            let imgs = document.querySelectorAll("img");
            Array.prototype.forEach.call(imgs, (element) => {
                element.removeAttribute("height");
            });
            setIframe(false);
            setIframeUrl(null);
        }
        else {
            // class 이름이 "media"가 아닌 경우
            setIframe(false);
            setIframeUrl(null);
        }
    }, [inform]);
    const editorOption = {
        toolbar: {
            items: [],
        },
        image: {
            toolbar: [],
        },
        table: {
            contentToolbar: [],
        },
        // link: {
        //   addTargetToExternalLinks: true
        // },
        removePlugins: ["ImageToolbar"],
        // shouldNotGroupWhenFull: true
    };
    useEffect(() => {
        if (item.informId != null) {
            let today = new Date();
            let formatToday = Number(dayjs(today).format("YYYYMMDD"));
            let storageName = window.location.pathname == "/main"
                ? "LANDING_TODAY_INFORM"
                : window.location.pathname == "/monitoring"
                    ? "BOARD_TODAY_INFORM"
                    : "";
            let isLocalToday = Number(window.localStorage.getItem(storageName));
            setInform(item);
            if (formatToday > isLocalToday) {
                setShow(propsShow);
            }
            else if (window.location.pathname == CONST.URL_MYPAGE) {
                setShow(propsShow);
            }
            else if (item.isViewOneDay == false) {
                setShow(propsShow);
            }
            else {
                setShow(false);
            }
        }
    }, [item, propsShow]);
    function closeInform() {
        if (window.location.pathname == CONST.URL_MYPAGE)
            props.setShow(false);
        if (inform.isViewOneDay)
            closeTodayRef.current.checked = false;
        setShow(false);
    }
    function downloadFile(url) {
        let a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("download", "");
        document.body.append(a);
        a.click();
        a.remove();
    }
    function openLink(url) {
        if (url != "") {
            window.open(url, "_blank");
        }
    }
    function checkToday() {
        let today = new Date();
        let storageName = window.location.pathname == "/main"
            ? "LANDING_TODAY_INFORM"
            : window.location.pathname == "/monitoring"
                ? "BOARD_TODAY_INFORM"
                : "";
        if (storageName != "")
            window.localStorage.setItem(storageName, dayjs(today).format("YYYYMMDD"));
        closeInform();
    }
    return (_jsx(_Fragment, { children: item != null && (_jsxs("div", Object.assign({ id: "pop-news", className: `popup-layer-news ${isShow ? "" : "hidden"} ${inform.position == 1 ? "center" : ""}` }, { children: [_jsx("div", Object.assign({ className: "popup__head" }, { children: _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: closeInform }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) })) })), _jsxs("div", Object.assign({ className: "popup__body" }, { children: [iframe ? (_jsx("div", Object.assign({ className: "cont" }, { children: inform && _jsx(CKEditor, { editor: Editor, data: inform.content, config: editorOption, disabled: true }) }))) : (_jsx("div", { dangerouslySetInnerHTML: { __html: inform.content }, onClick: (e) => openLink(inform.link), style: { cursor: inform.link != "" ? "pointer" : "" } })), inform.attachFiles != null ? (_jsx("ul", Object.assign({ className: "filelist" }, { children: inform.attachFiles &&
                                inform.attachFiles.map((item, index) => (_jsx("li", Object.assign({ onClick: (e) => downloadFile(item.url), style: { cursor: "pointer" } }, { children: _jsx("span", { children: item.name }) }), `informFile_${index}`))) }))) : ("")] })), inform.isViewOneDay && (_jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("input", { type: "checkbox", id: "close", name: "todayclose", ref: closeTodayRef, onClick: checkToday }), _jsx("label", Object.assign({ htmlFor: "close" }, { children: t("라벨.오늘하루그만보기") }))] })))] }))) }));
}
